import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

function ChequeModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Cheque Payment Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-3">
          <p className="mb-3">
            <strong>Please make cheque payable to Help Yateem and post to:</strong>
          </p>
          <div className="bg-light p-3 rounded mb-3">
            <p className="mb-1">St. Lukes Business Centre,</p>
            <p className="mb-1">Suit 2, 85 Tarling Road,</p>
            <p className="mb-0">London , E16 1HN</p>
          </div>
          <p className="mb-0">
            Please label your donations clearly with your name and any particular cause you would like your donation to be used for and please notify us when you have made your donation by emailing us at{' '}
            <a href="mailto:info@helpyateem.org">info@helpyateem.org</a>
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ChequeModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired
};

export { ChequeModal }; 